import React from 'react';

export default function FirmwareModal({ title, children, onClose, wide = false, className = '' }) {
  return (
    <div className="firmware-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        className={`firmware-modal${wide ? ' firmware-modal-wide' : ''}${className ? ` ${className}` : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="firmware-modal-header">
          <h3>{title}</h3>
          <button type="button" className="firmware-icon-button" onClick={onClose} aria-label={`Close ${title}`} title="Close">x</button>
        </div>
        {children}
      </section>
    </div>
  );
}
